{{ label() }}
@for (labelIcon of labelIcons(); track labelIcon.tooltip) {
    <div [title]="labelIcon.tooltip" style="display: inline-block">
        <svg sh-icon [size]="IconSize.SMALL" [name]="labelIcon.icon" style="margin-bottom: 0.2rem"></svg>
    </div>
}
